import { SimpleGrid } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import BarChartCircleAverageIcon from '@/ui/assets/BarChartCircleAverageIcon'
import DoneCheckIcon from '@/ui/assets/DoneCheckIcon'
import PersonIcon from '@/ui/assets/PersonIcon'
import SessionsIcon from '@/ui/assets/SessionsIcon'
import TherapistIcon from '@/ui/assets/TherapistIcon'

import MetricCard from '../../../Photos/components/MetricCard'
import { useCAAMetricsContext } from '../context/CAAMetricsContext'

export default function CAAMetricsCards() {
  const {
    t,
    i18n: { language }
  } = useTranslation()
  const numberFormat = Intl.NumberFormat(language, {
    maximumFractionDigits: 2
  })

  const { showPatient, metricsQuery } = useCAAMetricsContext()

  return (
    <SimpleGrid columns={4} gap={'6'}>
      <MetricCard
        icon={
          <DoneCheckIcon color={'custom.blue.darker'} h={'24px'} w={'24px'} />
        }
        label={t('caaMetrics.metrics.availability.label')}
        detailText={`${t('caaMetrics.metrics.availability.details.available', {
          count: metricsQuery?.data?.availability.available ?? 0
        })}${t('caaMetrics.metrics.availability.details.unavailable', {
          count: metricsQuery?.data?.availability.unavailable ?? 0
        })}`}
        value={`${numberFormat.format(
          metricsQuery?.data?.availability.percent ?? 0
        )}%`}
        info={t('caaMetrics.metrics.availability.info')}
        isLoading={!metricsQuery || metricsQuery.isFetching}
      />
      <MetricCard
        icon={<SessionsIcon color={'#077FDE'} h={'24px'} w={'24px'} />}
        label={t('caaMetrics.metrics.availableUsage.label')}
        detailText={`${t('caaMetrics.metrics.availableUsage.details.used', {
          count: metricsQuery?.data?.accession.used ?? 0
        })}${t('caaMetrics.metrics.availableUsage.details.notUsed', {
          count: metricsQuery?.data?.accession.notUsed ?? 0
        })}`}
        value={`${numberFormat.format(
          metricsQuery?.data?.accession.percent ?? 0
        )}%`}
        info={t('caaMetrics.metrics.availableUsage.info')}
        isLoading={!metricsQuery || metricsQuery.isFetching}
      />
      {showPatient ? (
        <MetricCard
          icon={
            <PersonIcon color={'custom.blue.darker'} h={'24px'} w={'24px'} />
          }
          label={t('caaMetrics.metrics.usageByPatient.label')}
          detailText={`${t('caaMetrics.metrics.usageByPatient.details.used', {
            count: metricsQuery?.data?.accessionTherapist.used ?? 0
          })}${t('caaMetrics.metrics.usageByPatient.details.notUsed', {
            count: metricsQuery?.data?.accessionTherapist.notUsed ?? 0
          })}`}
          value={`${numberFormat.format(
            metricsQuery?.data?.accessionTherapist.percent ?? 0
          )}%`}
          info={t('caaMetrics.metrics.usageByPatient.info')}
          isLoading={!metricsQuery || metricsQuery.isFetching}
        />
      ) : (
        <MetricCard
          icon={
            <TherapistIcon color={'custom.blue.darker'} h={'24px'} w={'24px'} />
          }
          label={t('caaMetrics.metrics.usageByTherapist.label')}
          detailText={`${t('caaMetrics.metrics.usageByTherapist.details.used', {
            count: metricsQuery?.data?.accessionTherapist.used ?? 0
          })}${t('caaMetrics.metrics.usageByTherapist.details.notUsed', {
            count: metricsQuery?.data?.accessionTherapist.notUsed ?? 0
          })}`}
          value={`${numberFormat.format(
            metricsQuery?.data?.accessionTherapist.percent ?? 0
          )}%`}
          info={t('caaMetrics.metrics.usageByTherapist.info')}
          isLoading={!metricsQuery || metricsQuery.isFetching}
        />
      )}
      <MetricCard
        icon={
          <BarChartCircleAverageIcon
            color={'custom.blue.darker'}
            h={'24px'}
            w={'24px'}
          />
        }
        label={t('caaMetrics.metrics.averageUsage.label')}
        detailText={t('caaMetrics.metrics.averageUsage.details')}
        value={`${numberFormat.format(metricsQuery?.data?.media ?? 0)}%`}
        info={t('caaMetrics.metrics.averageUsage.info')}
        isLoading={!metricsQuery || metricsQuery.isFetching}
      />
    </SimpleGrid>
  )
}
